import * as angular from "angular";
import {IController} from "angular";
import {SupplyAccountType} from "../../types/supply-account.type";
import {$accountsFactory} from "../../$accounts.factory";

export class SupplyAccountsTableCtrl implements IController {

  accountTypes: string[];
  type: string;
  queryString: string;
  selectedId: string;
  doReload: boolean;
  onReload: Function;
  onSelect: Function;

  public accountsRef: any;
  public loadLimit = 20;
  public infiniteScroll: any;
  public isScrollable: any;
  public selectedKeys: any;
  public supplyAccountsTypes: typeof SupplyAccountType = SupplyAccountType;


  constructor(private $infiniteScroll, private $accounts: $accountsFactory, private $log, private $mdMedia) {
  }

  $onInit() {
    this.accountsRef = this.$accounts();
    this.accountsRef.$query(this._getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.accountsRef, this.loadLimit);
    this.selectedKeys = {};
  };

  $onChanges(changes) {
    if (
      (changes.type && !changes.type.isFirstChange()) ||
      (changes.queryString && !changes.queryString.isFirstChange()) ||
      (changes.doReload && !changes.doReload.isFirstChange())
    ) {
      this._reload();
    }
  };

  $doCheck() {
    this.isScrollable = !this.$mdMedia('gt-sm');
  };

  private _reload() {
    this.onSelect({account: undefined});
    this.accountsRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
        this.onReload();
      })
      .catch((error) => {
        this.$log.error('Fail to $query', error);
      })
  }

  private _getQueryPayload() {
    return {
      isSupply: true,
      isExternal: this.type === this.supplyAccountsTypes.ThreePLSupply,
      type: this.type,
      query: this.queryString,
      limit: this.loadLimit
    }
  }
}

angular
  .module('bringoz.admin.accounts')
  .component('supplyAccountsTable', {
    bindings: {
      type: '<',
      accountTypes: '<',
      queryString: '<',
      selectedId: '<',
      doReload: '<',
      onReload: '&',
      onSelect: '&'
    },
    template: require('./supply-accounts-table.html').default,
    controller: SupplyAccountsTableCtrl
  });
